import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";
import { useRltWorkOrderUpdateStateMutation } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";

export function BackToPlanningDialog({ workOrder }: { workOrder: WorkOrder }) {
  const canAccess = useFeatureAuth("gsm.rlt.workorder.back-to-planning");
  const [patch, { isLoading, error }] = useRltWorkOrderUpdateStateMutation();

  const doForward = () => {
    if (isLoading) return;

    patch({
      id: workOrder.id,
      state: FulfillmentState.Planning,
    });
  };

  if (!canAccess) {
    return null;
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="secondary">{t("Neu Planen")}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Zur Planung zurück geben?")}</DialogTitle>
          <DialogDescription>
            {t(
              'Der Arbeitsschein wird als in "Planung" markiert. Er wird dann nicht mehr in der Ausführung angezeigt. Der Planer muss diesen dann neu Planen und zur Ausführung freigeben.',
            )}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doForward} />
      </DialogContent>
    </Dialog>
  );
}
